
import $ from "jquery";
$(document).ready(function(){
    $('.floorplan-button').click(function(){
        var element = $(this);

        var parent = element.parent().parent();
        // Toggle the visibility of the floorplan and main image
        parent.find('.main-image').toggle();
        parent.find('.floorplan-image').toggle();
        
        // Toggle the gradient overlay based on the visibility of the main image
        var overlay = parent.find('.gradient-overlay');
        if (parent.find('.main-image').is(':visible')) {
            overlay.css('opacity', '1'); // Show overlay if main image is visible
        } else {
            overlay.css('opacity', '0'); // Hide overlay if main image is hidden
        }

        var text_value = element.find('p');

        // Change the text and text color based on floorplan visibility
        if (parent.find('.floorplan-image').is(':visible')) {
            text_value.text('Hide Floorplan').css('color', 'black');
            parent.find('.floorplan-icon svg').addClass('rotate'); // Add rotation class to the <span>
            parent.find('.expand-button').fadeIn();
            parent.find('.garage').hide(); // Hide the garage bubble
        } else {
            text_value.text('Show Floorplan').css('color', 'white');
            parent.find('.floorplan-icon svg').removeClass('rotate'); // Remove rotation class from the <span>
            parent.find('.expand-button').fadeOut();
            parent.find('.garage').show(); // Show the garage bubble
        }
    });

    $('.expand-button').click(function(){
        var element = $(this);
        var parent = element.parent().parent().parent();
        parent.find('.featured_plan_popup').fadeIn();
    });

    if ($('.featured_plan_popup').length) {
        $('.featured_plan_popup').click(function(){
            var element = $(this);
            element.fadeOut();
        });
    }
});

